"use strict";
/**
 *
 * Ashish Patel
 * e: ashishsushilPatel@gmail.com
 * w: https://ashish.me
 *
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.API = void 0;
const axios_1 = __importDefault(require("axios"));
class APIClient {
    constructor(baseURL = "https://systemapi.prod.ashish.me") {
        this.todos = {
            getAll: async () => this.req("GET", `/todos`),
            create: async (params) => this.req("POST", `/todos`, params)
        };
        this.axios = axios_1.default.create({ baseURL: baseURL });
    }
    async req(method, url, body) {
        const res = (await this.axios.request({ method, url, data: body })).data;
        return res;
    }
}
exports.API = new APIClient();
